import { focusSafely } from '@react-aria/focus';
import { isFocusVisible } from '@react-aria/interactions';
import { getScrollParent, scrollIntoViewport } from '@react-aria/utils';
import type { FocusableElement } from '../../types.js';

/** Focuses the given element inside a table, and scrolls to it if focus is visible */
export function focusTableChild(element: FocusableElement): void {
  focusSafely(element);

  if (isFocusVisible()) {
    scrollIntoViewport(element, { containingElement: getScrollParent(element) });
  }
}
